import { useMemo } from "react"
import { ConfirmDialog } from "./ConfirmDialog"
import { useTranslation } from "@/hooks/useTranslation"

type DetailType = "cleaning" | "operation"

interface BackToDetailConfirmDialogProps {
    type: DetailType
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

export const BackToDetailConfirmDialog = ({
    type,
    open,
    onClose,
    onConfirm
}: BackToDetailConfirmDialogProps) => {
    const { t } = useTranslation()

    const CONFIRM_MESSAGES = useMemo<Record<DetailType, string>>(
        () => ({
            cleaning: t(
                "報告画面を閉じ、清掃詳細画面に戻ります。\nよろしいですか？\nアップロード済みの写真は削除されません。"
            ),
            operation: t(
                "報告画面を閉じ、ツアー詳細画面に戻ります。\nよろしいですか？\nアップロード済みの写真は削除されません。"
            )
        }),
        [t]
    )

    return (
        <ConfirmDialog
            open={open}
            message={CONFIRM_MESSAGES[type]}
            onConfirm={onConfirm}
            onCancel={onClose}
        />
    )
}
